/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/ban-ts-comment */
import React from 'react';
//@ts-ignore
import { HugeiconsIcon } from '@hugeicons/react';
//@ts-ignore
import { SentIcon } from '@hugeicons-pro/core-stroke-sharp';
//@ts-ignore
import { DashboardSquare02StrokeRounded,TimeScheduleStrokeRounded,Settings02StrokeRounded,ArrowLeftRightStrokeRounded,ConnectStrokeRounded,CollectionsBookmarkStrokeRounded } from '@hugeicons-pro/core-stroke-rounded';
//@ts-ignore
import {DashboardSquare02DuotoneRounded,TimeScheduleDuotoneRounded,Settings02DuotoneRounded,ConnectDuotoneRounded,CollectionsBookmarkDuotoneRounded } from '@hugeicons-pro/core-duotone-rounded';
import {MailOpenstrokeRounded,MailOpenDuotoneRounded, SentIconDuotoneRounded} from '../common/icons/customIcons';
import type {MenuItem} from './types/types';

export const MenuItems: MenuItem[] = [
  {
    id: 1,
    label: 'Dashboard',
    rightCode: "DASHBOARD",
    icon: <HugeiconsIcon
    icon={DashboardSquare02StrokeRounded}
    size={18}
    color="currentColor"
    strokeWidth={0.2}
  />,
    activeIcon: <HugeiconsIcon
    icon={DashboardSquare02DuotoneRounded}
    size={18}
    color="inherit"
    strokeWidth={0.2}
  />,
    link: '/dashboard'
  },
  {
    id: 2,
    rightCode: "TEMPLATE",
    icon: <MailOpenstrokeRounded 
    color="currentColor"
    strokeWidth={0.2}/>,
    activeIcon: <MailOpenDuotoneRounded color="inherit"
    strokeWidth={0.2} />,
    link: '/template'
  },
  {
    id: 3,
    rightCode: 'CAMPAIGN',
    icon: <HugeiconsIcon
    icon={SentIcon}
    size={18}
    color="currentColor"
    strokeWidth={0.2}
  />,
    activeIcon: <SentIconDuotoneRounded color="inherit"
    strokeWidth={0.2} />,
    link: '/campaigns'

  },
  {
    id: 4,
    rightCode: "LISTTRIGGER",
    icon: <HugeiconsIcon
    icon={TimeScheduleStrokeRounded}
    size={18}
    color="currentColor"
    strokeWidth={0.2}
  />,
    activeIcon: <HugeiconsIcon
    icon={TimeScheduleDuotoneRounded}
    size={18}
    color="inherit"
    strokeWidth={0.2}
  />,
    link: '/trigger'
  },
  {
    id: 5,
    rightCode:'BRAND_GROUPS',
    icon: <HugeiconsIcon
    icon={CollectionsBookmarkStrokeRounded}
    size={18}
    color="currentColor"
    strokeWidth={0.2}
  />,
    activeIcon: <HugeiconsIcon
    icon={CollectionsBookmarkDuotoneRounded}
    size={18}
    color="inherit"
    strokeWidth={0.2}
  />,
    link: '/brandsandgroups',
    subMenu: [
      {
        id: 51,
        link: '/brandsandgroups/manage-groups',
        rightCode:'GROUPS'
      },
      {
        id: 52,
        link: '/brandsandgroups/manage-brands',
        rightCode:'BRANDS'
      },
    ],
  },
  {
    id: 6,
    rightCode:'API_WEBHOOKS',
    icon: <HugeiconsIcon
    icon={ArrowLeftRightStrokeRounded}
    size={18}
    color="currentColor"
    strokeWidth={0.2}
  />,
    activeIcon: <HugeiconsIcon
    icon={ArrowLeftRightStrokeRounded}
    size={18}
    color="inherit"
    strokeWidth={0.2}
  />,
    link: '/apiandwebhooks',
    subMenu: [
      {
        id: 61,
        link: '/apiandwebhooks/manage-api',
        rightCode:'API_TOKEN'
      },
      {
        id: 62,
        link: '/apiandwebhooks/manage-webhooks',
        rightCode:'WEBHOOKS'
      },
    ],
  },

  {
    id: 7,
    rightCode:'SETTINGS',
    icon: <HugeiconsIcon
    icon={Settings02StrokeRounded}
    size={18}
    color="currentColor"
    strokeWidth={0.2}
  />,
    activeIcon:<HugeiconsIcon
    icon={Settings02DuotoneRounded}
    size={18}
    color="inherit"
    strokeWidth={0.2}
  />,
    link: '/settings',
    subMenu: [
      {
        id: 71,
        link: '/settings/manage-users',
        rightCode:'USERS'
      },
      {
        id: 72,
        link: '/settings/manage-roles',
        rightCode:'ROLES'
      },
      {
        id: 73,
        link: '/settings/manage-clients',
        rightCode:'CLIENTS'
      },
      {
        id: 74,
        link: '/settings/manage-appconfig',
        rightCode:'APPCONFIG'
      },
    ],
  },

  {
    id: 8,
    rightCode:'ESP',
    icon: <HugeiconsIcon
    icon={ConnectStrokeRounded}
    size={18}
    color="currentColor"
    strokeWidth={0.2}
  />,
    activeIcon:<HugeiconsIcon
    icon={ConnectDuotoneRounded}
    size={18}
    color="inherit"
    strokeWidth={0.2}
  />,
    link: '/email-api',
    //subMenu: [
      // {
      //   id: 81,
      //   link: '/email-api/manage-clients',
      //   menuFeatureKey:'EMAILAPI'
      // },
    //   {
    //     id: 82,
    //     link: '/email-api/esp-settings',
    //     menuFeatureKey:'ESPSETTINGS'
    //   }
    // ],
  },
];